/**
 * A list's query from its filter values as the API reads them (`filter[key]=value`, empty values
 * left out) and its order — for an export link from a page whose filters live in component state
 * (FRD-CORE-040). Pass the result to `exportHref`.
 */
export function filterQuery(
  filters: Readonly<Record<string, string>>,
  sort?: string,
): URLSearchParams {
  const query = new URLSearchParams(sort === undefined ? {} : { sort });
  for (const [key, value] of Object.entries(filters)) {
    if (value !== '') query.set(`filter[${key}]`, value);
  }
  return query;
}
